import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import TranscriptCourseStatusDomainService from "../../../Domain/TranscriptCourseStatus/TranscriptCourseStatus.service";
const getBadgeColor = (status) => {
    switch (status === null || status === void 0 ? void 0 : status.id) {
        case TranscriptCourseStatusDomainService.DroppedId:
            return "danger";
        case TranscriptCourseStatusDomainService.RegisteredId:
            return "success";
        case TranscriptCourseStatusDomainService.PurgedByInstitutionId:
            return "danger";
        case TranscriptCourseStatusDomainService.WaitlistId:
            return "warning";
        case TranscriptCourseStatusDomainService.WithdrawInProgressId:
            return "info";
        case TranscriptCourseStatusDomainService.WithdrawnId:
            return "danger";
        case TranscriptCourseStatusDomainService.UnknownId:
            return "secondary";
        case TranscriptCourseStatusDomainService.DeletedId:
            return "danger";
        case TranscriptCourseStatusDomainService.WebwithdrawnId:
            return "danger";
        default:
            return "secondary";
    }
};
const TranscriptCourseStatusBadge = ({ status, className, title, }) => status && (_jsx("span", { className: `badge badge-${getBadgeColor(status)} ${className !== null && className !== void 0 ? className : ""}`, title: title !== null && title !== void 0 ? title : status.description, children: status.description }));
export default TranscriptCourseStatusBadge;
